import Icon from '../components/Icon.vue'

Icon.register({"exclamation":{"width":640,"height":1792,"paths":[{"d":"M512 1248v224q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-224q0-26 19-45t45-19h256q26 0 45 19t19 45zM542 192l-28 768q-1 26-20.5 45t-45.5 19h-256q-26 0-45.5-19t-20.5-45l-28-768q-1-26 17.5-45t44.5-19h320q26 0 44.5 19t17.5 45z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/exclamation.js